// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"cc52902f","453":"feaf8129","773":"f4f3563b","928":"00769a8d"}[chunkId] + ".chunk.js";
};